import EmailInput from "@/app/components/common/actions/inputs-b/EmailInput";
import { DATA_GIF_PATH } from "@/app/utils/config";
import Otp from "./Otp";
import { useState } from "react";

export default function UAEPASSConnect() {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [email, setEmail] = useState("sanath@growx.global");
  const [emailValid, setEmailValid] = useState(true);
  const [triggerValidation, setTriggerValidation] = useState(false);

  const handleContinue = () => {
    setTriggerValidation(true);
    if (!emailValid) {
      return;
    }
    sessionStorage.setItem("email", email);
    const generatedOtp = "123456";
    sessionStorage.setItem("email-otp", generatedOtp);
    setShowOtpModal(true);
  };

  const handleEditEmail = () => {
    setShowOtpModal(false);
  };

  return (
    <div className="gx-userdetails-card">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <div className="gx-login-success-img">
            <img src={`${DATA_GIF_PATH}done_animation.gif`} alt="Success" />
          </div>
        </div>
        <div className="col-span-12">
          <div className="gx-request-progress-title">
            <h2 className="gx-h2-l">UAE PASS </h2>
            <span className="gx-h2-b">Connected Successfully</span>
            <p className="gx-p12-m">
              Your UAE PASS account has been securely linked and your identity
              has been verified successfully.
            </p>
          </div>
        </div>
        <div className="col-span-12">
          <div className="gx-userdetails-box">
            <h3 className="gx-userdetails-title">User Details</h3>

            <div className="gx-userdetails-content">
              <div className="gx-detail-row">
                <span>First Name</span>
                <strong>Mohammed</strong>
              </div>

              <div className="gx-detail-row">
                <span>Last Name</span>
                <strong>Ali</strong>
              </div>

              <div className="gx-detail-row">
                <span>Country</span>
                <strong>United Arab Emirates</strong>
              </div>

              <div className="gx-detail-row">
                <span>Emirates ID</span>
                <strong>784-1990-1234567-1</strong>
              </div>

              <div className="gx-detail-row">
                <span>Mobile Number</span>
                <strong>+971 55 879 7889</strong>
              </div>
            </div>

            <div className="gx-email-wrapper">
              <EmailInput
                label="Email ID"
                value={email}
                onChange={setEmail}
                triggerValidation={triggerValidation}
                onValidate={(_, isValid) => setEmailValid(isValid)}
                starlable
              />
            </div>
          </div>
        </div>
        <div className="col-span-12">
          <div className="gx-footer-btn-center">
            <div className="login-continue-btn">
              <button onClick={handleContinue} className="gx-p16-eb">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      {showOtpModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <Otp onEditEmail={handleEditEmail} />
          </div>
        </div>
      )}
    </div>
  );
}
